module.exports = __webpack_public_path__ + "668484133c10fc6be71672b80d9b6856.svg";